import React from 'react';
import{Link} from 'react-router-dom'
import {motion} from 'framer-motion'
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import './movieCard.css'

function MovieCard({title, poster_path, id, vote_average
}) {
    const imgUrl = 'https://image.tmdb.org/t/p/w500/';
  return (
          <Link to={`/movie/${id}`} className='card'>
            <motion.div
              initial={{ opacity: 0.2}}
              whileHover={{
                scale: 1.1,
                transition: { duration: 0.3 }
              }}
              whileInView={{ opacity: 1 }}
              transition={{duration:1}}
              >
                <Card>
                  <CardMedia
                  className='card-img'
                    component="img"
                    image={`${imgUrl+poster_path}`} alt={title} 
                    />
                  <CardContent style={{
                    background: '#2F3441'
                  }} className="card-contents">
                    <Typography variant='body2' className='card-content'>{title}</Typography>
                    <Typography variant='body2' className='card-content'>{vote_average}/10</Typography>
                  </CardContent>                     
                    
    </Card>
            </motion.div>
          </Link>
  )
}



export default MovieCard